export default __webpack_public_path__ + "static/media/sendIcon.c210bdd2.svg";